import React, { useEffect, useRef, useState } from 'react';
import { useVideoInputs } from 'amazon-chime-sdk-component-library-react';
import { PreviewBackdrop, PreviewVideo } from './style';

const CameraPreview = () => {
  const { selectedDevice } = useVideoInputs();
  const videoRef = useRef(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    let localStream = null;
    let cancelled = false;
    setIsReady(false);

    const deviceId =
      typeof selectedDevice === 'string'
        ? selectedDevice
        : selectedDevice?.deviceId || null;

    const constraints = deviceId
      ? { video: { deviceId: { exact: deviceId } }, audio: false }
      : { video: true, audio: false };

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        if (cancelled) {
          stream.getTracks().forEach((track) => track.stop());
          return;
        }
        localStream = stream;
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.onloadedmetadata = () => {
            if (!cancelled) {
              setIsReady(true);
              videoRef.current?.play?.().catch(() => {});
            }
          };
        } else {
          stream.getTracks().forEach((track) => track.stop());
        }
      })
      .catch(() => {});

    return () => {
      if (localStream) {
        localStream.getTracks().forEach((t) => t.stop());
      }
      cancelled = true;
    };
  }, [selectedDevice]);

  return (
    <>
      <PreviewBackdrop aria-hidden="true" $isReady={isReady} />
      <PreviewVideo ref={videoRef} autoPlay muted playsInline $isReady={isReady} />
    </>
  );
};

export default CameraPreview;
